import { ChatMessage } from './database';

interface SeedMessages {
  [characterId: string]: ChatMessage[];
}

export const SEED_MESSAGES: SeedMessages = {
  '1': [ // Pixel Pete's messages
    {
      id: 'seed-1-3',
      characterId: '1',
      content: 'Hey... Can you see this message?',
      timestamp: Date.now() - 86400000,
      isUser: false
    },
    {
      id: 'seed-1-1',
      characterId: '1',
      content: 'Image',
      timestamp: Date.now() - 86400000 * 2, // 2 days ago
      isUser: false
    },
  ],
  '2': [ // Gif Queen's messages
    {
      id: 'seed-2-2',
      characterId: '2',
      content: 'Hey there! I\'m Mina. How are you doing today?',
      timestamp: Date.now() - 86400000 * 3 + 1000,
      isUser: false
    },
    {
      id: 'seed-2-1',
      characterId: '2',
      content: 'https://assets.snackbook.cc/mina/bed2.png',
      timestamp: Date.now() - 86400000 * 3,
      isUser: false
    },
  ],
  '3': [ // Photo Pro's messages
    {
      id: 'seed-3-2',
      characterId: '3',
      content: 'https://assets.snackbook.cc/annie/ltv8YGbMqmR6Hp7yNZPsJ_6da44b2f12044a0fa3361a73bbccb8ba.jpg',
      timestamp: Date.now() - 86400000 * 4 + 1000,
      isUser: false
    },
    {
      id: 'seed-3-1',
      characterId: '3',
      content: 'Hey there! I\'m Annie. How are you doing today?',
      timestamp: Date.now() - 86400000 * 4,
      isUser: false
    },
  ]
};